
export const Component = () => {
    return (
        <div>404 - Página no encontrada</div>
    );
};

export { Component as NotFoundPage }